import { Redirect, Route, Switch, useLocation } from 'react-router'

import {
  SystemConfigurationContext,
  useUniversalLogin,
} from '@signavio/effektif-api'

import { PublicRoute } from '../components'
import { ForgotPassword, Login, Registration } from '../login'

function Session({ children }) {
  const location = useLocation()

  const [session, systemConfiguration] = useUniversalLogin()

  if (!systemConfiguration) {
    return null
  }

  const {
    registrationEnabled,
    authenticationProviders,
    centralRegistrationEnabled,
    processManagerUrl,
  } = systemConfiguration

  if (session.sessionState === 'unknown') {
    return null
  }

  return (
    <SystemConfigurationContext.Provider value={systemConfiguration}>
      <Switch>
        <PublicRoute path="/login" component={Login} />

        <Redirect from="/try" to="/registration" />

        {registrationEnabled && (
          <PublicRoute
            path={
              centralRegistrationEnabled
                ? '/registration/:id'
                : // the ? at the end also allows /registration
                  '/registration/:id?'
            }
            component={Registration}
          />
        )}

        {centralRegistrationEnabled && (
          <Route
            path="/registration"
            render={() => {
              window.location.href = `${processManagerUrl}/p/register`

              return null
            }}
          />
        )}

        {authenticationProviders.includes('password') && (
          <PublicRoute path="/password" component={ForgotPassword} />
        )}

        {session.sessionState === 'loggedIn' ? (
          !session.preventApplicationRender &&
          children({ user: session.user, organization: session.organization })
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )}
      </Switch>
    </SystemConfigurationContext.Provider>
  )
}

export default Session
